import React, { useContext, useState, useEffect } from 'react'
import { AuthContext } from '../context/AuthContext'
import { getConfig } from './service/studyService'
import './study.scss'

// Auth gate for the study routes.
//
// Replaces the generic ProtectedRoute here. That one redirects to /login, which is wrong
// for this audience twice over: a participant who lands on bare /study gets a VizPI sign-in
// page that explains nothing, and the "Join as Guest" button on it would mint a BRAND NEW
// participant — new user id, fresh record, counterbalance cell lost — which is exactly the
// failure invite tokens exist to prevent. (It would error first anyway: registerAsGuest
// reads the session id off the URL tail, which on /study is the string "study".)
//
// So: no redirect. Say plainly that entry is by personal link.
export default function StudyGate ({ children }) {
  const { currentUser, currentUserLoading } = useContext(AuthContext)
  const [config, setConfig] = useState(null)

  useEffect(() => { getConfig().then(setConfig).catch(() => setConfig({ testMode: false })) }, [])

  if (currentUserLoading || !config) {
    return (
      <div className="study-root study-login">
        <div className="study-card"><p>Loading…</p></div>
      </div>
    )
  }

  // Test mode is local-only (testMode.js hard-refuses under a production NODE_ENV), and a
  // walkthrough needs to reach the flow without minting an invite link each time. The
  // type-in login lives on StudyPage's own no-participant screen.
  if (config.testMode) return children

  if (!currentUser) {
    return (
      <div className="study-root study-login">
        <div className="study-card">
          <h1 className="study-h1">VizPI Study</h1>
          <p>
            Please open the personal study link from your invitation email. It’s unique to
            you, and it’s the same link for every part of the study.
          </p>
          <p className="study-hint">
            Can’t find it? Contact the research team and we’ll resend it.
          </p>
        </div>
      </div>
    )
  }

  return children
}
